import { render, staticRenderFns } from "./IadeArizaTedarikciMail.vue?vue&type=template&id=15967a52&"
import script from "./IadeArizaTedarikciMail.vue?vue&type=script&lang=js&"
export * from "./IadeArizaTedarikciMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports